import { render, staticRenderFns } from "./SamTable.vue?vue&type=template&id=2e4a6010&scoped=true&"
import script from "./SamTable.vue?vue&type=script&lang=js&"
export * from "./SamTable.vue?vue&type=script&lang=js&"
import style0 from "./SamTable.vue?vue&type=style&index=0&id=2e4a6010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a6010",
  null
  
)

export default component.exports